// extracted by mini-css-extract-plugin
export default {"startMobileWrap":"styles_startMobileWrap__tO4tF","button":"styles_button__UtbVD"};